import { Box, Flex, Text, VStack, Link, useColorModeValue } from "@chakra-ui/react";
import { FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa";

const Footer = () => {
    const bg = useColorModeValue('white', '#1C1C1C');
    const color = useColorModeValue('#FFFFF', 'white');

    return (
        <Box as="footer" color={color} w="100%" p={10} mt={{ base: "50px", md: "110px" }} bg={bg}>
            <Flex
                direction={{ base: "column", md: "row" }}
                justify="space-between"
                align="flex-start"
                maxW="1200px"
                mx="auto"
                pl={{ base: 4, md: 16 }}
                pr={{ base: 4, md: 16 }}
                gap={10}
            >
                <VStack align="start" spacing={3} w={{ base: "100%", md: "auto" }} fontFamily="'Gilroy-SemiBold', sans-serif">
                    <Text fontSize="30px" fontWeight="bold" fontFamily="'Gilroy-Regular', sans-serif">
                        Explore More
                    </Text>
                    <Link href="/" fontWeight="bold" _hover={{ color: "red.500" }}>Home</Link>
                    <Link href="/service" fontWeight="bold" _hover={{ color: "red.500" }}>Service</Link>
                    <Link href="/about" fontWeight="bold" _hover={{ color: "red.500" }}>About</Link>
                    <Link href="/contact" fontWeight="bold" _hover={{ color: "red.500" }}>Contact</Link>
                </VStack>

                <VStack align="start" spacing={3} w={{ base: "100%", md: "auto" }} fontFamily="'Gilroy-SemiBold', sans-serif">
                    <Text fontSize="30px" fontWeight="bold" fontFamily="'Gilroy-Regular', sans-serif">
                        Services
                    </Text>
                    <Link href="/digitalbranding" fontWeight="bold" _hover={{ color: "red.500" }}>Digital Branding Solutions</Link>
                    <Link href="/awarenesssoutions" fontWeight="bold" _hover={{ color: "red.500" }}>Awareness Growth Solutions</Link>
                    <Link href="/revenuegrowth" fontWeight="bold" _hover={{ color: "red.500" }}>Revenue Growth Solutions</Link>
                    <Link href="/socialmedia" fontWeight="bold" _hover={{ color: "red.500" }}>Social Media Management</Link>
                    <Link href="/seo" fontWeight="bold" _hover={{ color: "red.500" }}>SEO</Link>
                    <Link href="/performancemarketing" fontWeight="bold" _hover={{ color: "red.500" }}>Performance Marketing</Link>
                </VStack>

                <VStack
                    align="start"
                    spacing={3}
                    w={{ base: "100%", md: "auto" }}
                    fontFamily="'Gilroy-SemiBold', sans-serif"
                >
                    <Text fontSize="30px" fontWeight="bold" fontFamily="'Gilroy-Regular', sans-serif">
                        Address
                    </Text>

                    <Link href="mailto:example@gmail.com" fontWeight="bold" _hover={{ color: "red.500" }}>
                        info@raretoss.com
                    </Link>

                    {/* <Link href="tel:+913654225631" fontWeight="bold" _hover={{ color: "red.500" }}>
                        +91 36542 25631
                    </Link> */}

                    <VStack align="start" spacing={1}>
                        <Link fontWeight="bold" _hover={{ color: "red.500" }}>
                            Abhisgree Adroit Near
                        </Link>
                        <Link fontWeight="bold" _hover={{ color: "red.500" }}>
                            Mansi Circle, Ahmedabad
                        </Link>
                    </VStack>
                </VStack>
            </Flex>

            <Flex
                direction={{ base: "column", md: "row" }}
                justify="center"
                align="center"
                mt={8}
                borderTop="1px solid gray"
                pt={4}
                gap={4}
                maxW="1200px"
                mx="auto"
                pl={{ base: 4, md: 16 }}
                pr={{ base: 4, md: 16 }}
            >
                <Text fontSize={{ md: "25px", base: "20px" }} textAlign="center" fontWeight="bold" fontFamily="'Gilroy-Regular', sans-serif">
                    All rights Reserved 2024 - Designed by @techbuilders
                </Text>
            </Flex>
        </Box>
    );
};

export default Footer;
